module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray-3 p-t-md p-b-md"
  }, [_vm._v("\n  " + _vm._s( /** 案件及价格 */ ) + "\n  "), _c('div', {
    staticClass: "p-a-lg bg-white inner-content po-r"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_vm._v("应付金额: "), _c('span', {
    staticClass: "text-price"
  }, [_vm._v("¥"), _c('span', {
    staticClass: "big-price"
  }, [_vm._v(_vm._s(_vm.cas.reservePrice / 100 || ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "pay-header"
  }, [_vm._v("案例：" + _vm._s(_vm.cas.title))])]), _vm._v("\n  " + _vm._s( /** 支付 */ ) + "\n  "), _c('div', {
    staticClass: "bg-white paying-wrp p-a-lg inner-content m-t-md"
  }, [_c('div', [_c('span', {
    class: {
      'pay-icon': true,
      active: _vm.activePayment === 2
    },
    on: {
      "click": function($event) {
        _vm.activePayment = 2
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/weixin.png")
    }
  }), _c('span', [_vm._v("微信支付")])]), _vm._v(" "), _c('span', {
    class: {
      'pay-icon': true,
      active: _vm.activePayment === 1
    },
    on: {
      "click": function($event) {
        _vm.activePayment = 1
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/zhifubao.png")
    }
  }), _c('span', [_vm._v("支付宝支付")])])]), _vm._v(" "), _c('div', {
    staticClass: "pay-amount m-b-lg"
  }, [_vm._v("应付金额: "), _c('span', {
    staticClass: "text-price"
  }, [_vm._v("¥"), _c('span', {
    staticClass: "big-price"
  }, [_vm._v(_vm._s(_vm.cas.reservePrice / 100 || ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "pay-btn-wrp"
  }, [_c('button', {
    staticClass: "c-b c-b-pay m-r-lg",
    attrs: {
      "disabled": !_vm.agreed
    },
    on: {
      "click": _vm.pay
    }
  }, [_vm._v("去付款")]), _vm._v(" "), _c('span', {
    staticClass: "text-primary",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    staticClass: "m-t-md gray-5 pay-agree"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreed),
      expression: "agreed"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.agreed) ? _vm._i(_vm.agreed, null) > -1 : (_vm.agreed)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.agreed,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agreed = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.agreed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agreed = $$c
        }
      }
    }
  }), _vm._v(" 我已阅读并同意《****》协议")])])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading-mod"
  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('vue-loading', {
    staticStyle: {
      "z-index": "20000",
      "position": "fixed",
      "top": "40%",
      "left": "47%",
      "opacity": "1"
    },
    attrs: {
      "type": "spiningDubbles",
      "color": "#000000",
      "size": {
        width: '50px',
        height: '50px'
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "top": "53%",
      "left": "46%"
    }
  }, [_vm._v("支付跳转中")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-704b7c27"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pay.vue
// module id = 608
// module chunks = 1